import React, { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import DashboardHeader from '../../header/DashboardHeader';
import RoundButton from '../../common/RoundButton';
import SuccessImage from "../../../assets/images/Group 3746.svg";
import { useAuth } from '../../auth/Auth';
import { GUARDIAN_SETTINGS_ROUTE } from "../../../constants/routes.constants";
import { isPayByCamp } from '../../../utils/utils';

const VerificationPaymentSuccess = () => {
  const { guardian, refreshUserState } = useAuth();
  const location = useLocation();
  // const dependent = useMemo(() => guardian.dependents.length?guardian.dependents[0]:{})
  const dependent = location?.state?.dependent;
  const history = useHistory();
  // console.log(location);
  // console.log(dependent);

  const pageRedirect = () => {
    // localStorage.removeItem("set_dependent");
    refreshUserState();
    if (location?.state?.isUpgrade) {
      history.push({
        pathname: GUARDIAN_SETTINGS_ROUTE,
        state: {
          childCreated: true,
          isUpgrade: true,
          dependent: dependent,
        },
      });
    } else {
      history.push({
        pathname: GUARDIAN_SETTINGS_ROUTE,
        state: {
          childCreated: true,
          from: 'verified',
          dependent: dependent,
        },
      });
    }
  };

  const getPlan = () => {
    if (isPayByCamp(dependent?.school_details?.pay_by)) {
      return 'Seedlings';
    } else {
      if (dependent?.is_verified) {
        if (dependent?.subscriptions?.nickname === 'Roots') return 'Roots';
        if (dependent?.subscriptions?.nickname === 'Branches')
          return 'Branches';
        if (dependent?.subscriptions?.nickname === 'Seedlings V2')
          return 'Seedlings';
        if (dependent?.subscriptions?.nickname === 'Villagers')
          return 'Villagers';
        if (dependent?.subscriptions?.nickname === 'Emeralites') {
          return 'Emeralites';
        } else {
          return 'Emeralites';
        }
      }
    }
  };

  return (
    <div>
      <DashboardHeader />
      <div className="add-more-branches verification-gaurdian veryfied-now">
        <Container>
          <div className="d-flex justify-content-center">
            <div>
              <div className="d-flex justify-content-center">
                <img className="mb-4" src={SuccessImage} />
              </div>
              <div className="text-center">
                <h3 className="mt-4">Welcome to the {getPlan()} Plan!</h3>
                <Row className="mt-4">
                  <Col>{dependent.first_name}'s account is all set.</Col>
                </Row>
                <Row>
                  <Col>Enjoy your TaleTree experience!</Col>
                </Row>

                <RoundButton
                  type="button"
                  label="FINISH"
                  onClick={pageRedirect}
                  className="gred-btn mt-80 w-100 change-password-button btn-success txt-white"
                />
              </div>
            </div>
          </div>
        </Container>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default VerificationPaymentSuccess;